import { render } from "./ScIcon.vue?vue&type=template&id=acb3a262"
import script from "./ScIcon.vue?vue&type=script&lang=js"
export * from "./ScIcon.vue?vue&type=script&lang=js"

import "./ScIcon.vue?vue&type=style&index=0&id=acb3a262&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__